// extracted by mini-css-extract-plugin
export default {"container":"crODr","contentWrapper":"Hg7gm","products":"_4OoVy","cartSum":"ize4c","cartSumItem":"lj+D4","cartSumMva":"+lWQj"};